import { BaseItemStore } from "../core/BaseStore";
import type SuperUserModel from "./SuperUserModel";

export default class SuperUsersStore extends BaseItemStore<SuperUserModel> {}
